import { useState } from "react";

export type UserData = {
  username: string;
  phone: string;
  telegram?: string;
  service: string;
  email: string;
};

export const useBooking = () => {
  // Шаг 1 стартовый шаг, 3 шаг с соглашениями
  const [step, setStep] = useState(1);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [selectedSlot, setSelectedSlot] = useState<string | null>(null);
  const [userData, setUserData] = useState<UserData>({
    username: "",
    phone: "",
    telegram: "",
    service: "",
    email: "",
  });

  const goToNextStep = () => setStep((prev) => Math.min(prev + 1, 4));
  const goToPrevStep = () => setStep((prev) => Math.max(prev - 1, 1));

  const resetBooking = () => {
    setStep(1);
    setSelectedDate(null);
    setSelectedSlot(null);
    setUserData({
      username: "",
      phone: "",
      telegram: "",
      service: "",
      email: "",
    });
  };

  return {
    step,
    selectedDate,
    selectedSlot,
    userData,
    setSelectedDate,
    setSelectedSlot,
    setUserData,
    goToNextStep,
    goToPrevStep,
    resetBooking,
  };
};
